import { defineNuxtPlugin } from '#app'

import { defineCustomElements, applyPolyfills } from '@nuiverse/core/dist/loader';

export default defineNuxtPlugin(async () => {
  await applyPolyfills();
  await defineCustomElements(window);
})